import { InventoryLookupResponse } from '@model/erp/inventory-lookup';

class ErpServiceConfig {
  /** @type {string} */
  baseUrl = '';
  endpoints = {};

  static defaultEndpoints = {
    "health": "/health",
    "webhooks": "/webhooks",
    "pricing": "/pricing",
    "cart": "/cart",
    "inventoryLookup": "/inventory-lookup",
  }

  static default_nonprod() {
    const instance = new ErpServiceConfig();
    instance.baseUrl = 'https://api-nonprod.mw.building-controls.com/';
    instance.endpoints = ErpServiceConfig.defaultEndpoints;
    return instance;
  }

  static default_prod() {
    const instance = new ErpServiceConfig();
    instance.baseUrl = 'https://api.mw.building-controls.com/';
    instance.endpoints = ErpServiceConfig.defaultEndpoints;
    return instance;
  }
}

export class ErpService {

  /** @type {ErpServiceConfig} */
  config;

  static nonprod() {
    const instance = new ErpService();
    instance.config = ErpServiceConfig.default_nonprod();
    return instance;
  }

  static prod() {
    const instance = new ErpService();
    instance.config = ErpServiceConfig.default_prod();
    return instance;
  }

  /** @param {ErpServiceConfig} config */
  constructor(config) {
    this.config = config;
  }

  /** @param {string} endpoint */
  forEndpoint(endpoint) {
    if ("string" === typeof endpoint) {
      if (endpoint.startsWith('/')) {
        endpoint = endpoint.substring(1);
      }
      return `${this.config.baseUrl}${endpoint}`;
    }
  }

  /**
   * @param {string} endpoint
   * @param {string} method
   * @param {string} body
   * @returns {Promise<Response>}
   */
  async call(endpoint, method, body) {
    if ("string" !== typeof body) {
      body = JSON.stringify(body);
    }

    const response = await fetch(endpoint, {
      method: method,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: body,
    });
    return response;
  }

  /**
   * Lookup inventory by SKU.
   * @param request
   * @returns {Promise<InventoryLookupResponse>}
   */
  async inventoryLookup(request) {
    const endpoint = this.forEndpoint(this.config.endpoints.inventoryLookup);
    const method = 'POST';
    const response = await this.call(endpoint, method, request);
    const json = await response.json();
    const result = new InventoryLookupResponse().fromJson(json);
    return result;
  }


}

const erpService = ErpService.prod();

export default erpService;